import fetchApi from "../fetchApi";
import useAuth from "../../hooks/useAuth";
import { useQuery } from "@tanstack/react-query";

const useQueryAutomobile = (options?: any) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ["Automobile"],
    queryFn: () => fetchApi("projects", token).get(),
    staleTime: 10000 * 60 * 10,
    refetchOnWindowFocus: false,
  });
};

export default useQueryAutomobile;
